import { render, staticRenderFns } from "./Malfunction.vue?vue&type=template&id=e1d8e242&scoped=true"
import script from "./Malfunction.vue?vue&type=script&lang=ts"
export * from "./Malfunction.vue?vue&type=script&lang=ts"
import style0 from "./Malfunction.vue?vue&type=style&index=0&id=e1d8e242&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1d8e242",
  null
  
)

export default component.exports